import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CountryMaster } from './country_master/country_master.component';
import { regionMaster } from './region_master/region_master.component';
import { stateMaster } from './state_master/state_master.component';
import { cityMaster } from './city_master/city_master.component';
import { areaMaster } from './area_master/area_master.component';
import { branchMaster } from './branch_master/branch_master.component';
import { configDepartment } from './configure_department/department.component';
import { configDesignation } from './configure_designation/designation.component';
import { configDocument } from './configure_document/document.component';
import { PinAreaMaster } from './PinCode_Area_master/pincode_area_master.component';
import { AuthGuard, SharedModule } from '../../shared';
import { GeographyMasterService } from './geography_master.service';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';

const GeographyMasterRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'setting/countryMaster',
    component: CountryMaster,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }, {
    path: 'setting/region-Master',
    component: regionMaster,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }, {
    path: 'setting/state-Master',
    component: stateMaster,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }
  , {
    path: 'setting/city-Master',
    component: cityMaster,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }, {
    path: 'setting/area-Master',
    component: areaMaster,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }, {
    path: 'setting/branch-Master',
    component: branchMaster,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }, {
    path: 'setting/pin-area-Master',
    component: PinAreaMaster,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }, {
    path: 'setting/config-department',
    component: configDepartment,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }, {
    path: 'setting/config-designation',
    component: configDesignation,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }, {
    path: 'setting/config-document',
    component: configDocument,
    canActivate: [AuthGuard],
    pathMatch: 'full'
  }
]);

@NgModule({
  imports: [  
    SharedModule,
    GeographyMasterRouting,
    NgbModule,
    AngularMultiSelectModule
  ],
  declarations: [
    CountryMaster,
    regionMaster,
    stateMaster,
    cityMaster,
    areaMaster,
    branchMaster,
    PinAreaMaster,
    configDepartment,
    configDesignation,
    configDocument
  ],
  providers: [
 GeographyMasterService
  ],
})
export class GeographyModule {}


// WEBPACK FOOTER //
// ./src/app/system_setting/geography_master/geography_master.module.ts